const getDoctorsApiUrl = () => process.env.REACT_APP_URL_PROD_MEDAM;
// process.env.REACT_APP_PROD_MEDAM || process.env.REACT_APP_URL_PROD_MEDAM;

const normalizeDoctor = (doctor = {}) => {
  const especialidad =
    Array.isArray(doctor.especialidad) && doctor.especialidad.length > 0
      ? doctor.especialidad[doctor.especialidad.length - 1]?.label || ""
      : "";

  return {
    ...doctor,
    especialidad,
  };
};

export const getDoctorsFromApi = async ({ query = "" } = {}) => {
  const baseUrl = (getDoctorsApiUrl() || "").replace(/\/+$/, "");

  if (!baseUrl) {
    return [];
  }

  try {
    const response = await fetch(
      `${baseUrl}/employees/listOfEmployees/doctor`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      },
    );
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const payload = await response.json();
    if (!Array.isArray(payload?.data)) {
      return [];
    }
    const data = payload.data.map((doctor, index) =>
      normalizeDoctor(doctor, index),
    );
    console.log("DATA", data);

    return data;
  } catch (error) {
    console.error("No se pudieron cargar los doctores:", error);
    return [];
  }
};
